import { NavBarConfig, VerifyStageEnum } from './types';
import NAVBAR_BG_IMAGE from './images/navbar-bg@3x.png';

export const VerifyStageTitle = {
  [VerifyStageEnum.USER_BASE]: '个人信息',
  [VerifyStageEnum.CONTACT_INFO]: '紧急联系人',
  [VerifyStageEnum.ID_CARD]: '身份认证',
  [VerifyStageEnum.BIO_AUTH]: '人脸认证',
  [VerifyStageEnum.TWO_ELEMENTS]: '实名认证',
};

/** 各资料步骤-沉浸式导航栏配置生成器 */
export const genNavBarConfig = (stage: VerifyStageEnum): NavBarConfig => {
  const title = VerifyStageTitle[stage] || '';

  switch (stage) {
    case VerifyStageEnum.USER_BASE:
    case VerifyStageEnum.CONTACT_INFO:
      return {
        title,
        backgroundImage: NAVBAR_BG_IMAGE,
        containerAdaptBgImage: true,
        backgroundColor: '#dde6eb',
      };
    case VerifyStageEnum.ID_CARD:
    case VerifyStageEnum.BIO_AUTH:
    case VerifyStageEnum.TWO_ELEMENTS:
      return {
        title,
        backgroundImage: '',
        backgroundColor: '#fff',
      };
    default:
      return {
        title,
        backgroundImage: '',
        backgroundColor: '#fff',
      };
  }
};
